import { useSelector } from "react-redux"

const useRateBtns = () => {
    const { wavesurfer } = useSelector(state => state.wavesurfer)

    const changeDuration = (duration) => {
        wavesurfer.setPlaybackRate(duration)
    }

    const rateBtns = [
        {
            id: 0.5,
            label: "0.5",
            action: () => changeDuration(0.5),
            markSelected: true
        },
        {
            id: 0.75,
            label: "0.75",
            action: () => changeDuration(0.75),
            markSelected: true

        },
        {
            id: 1,
            label: "1.0",
            action: () => changeDuration(1),
            markSelected: true

        },
        {
            id: 1.5,
            label: "1.5",
            action: () => changeDuration(1.5),
            markSelected: true
        }
    ]

    return rateBtns
}

export default useRateBtns